import * as React from "react"

import GlobalHeader from "./global-header"
import GlobalFooter from "./global-footer"
import Header from "./header"

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]', {
    offset: 90
  })
}

const Layout = ({ location, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <GlobalHeader />
      <Header />
      <main>{children}</main>
      <GlobalFooter />
    </div>
  )
}

export default Layout
